import { render, staticRenderFns } from "./CampanhaFormPage.vue?vue&type=template&id=8d35b10c&scoped=true"
import script from "./CampanhaFormPage.vue?vue&type=script&lang=js"
export * from "./CampanhaFormPage.vue?vue&type=script&lang=js"
import style0 from "./CampanhaFormPage.vue?vue&type=style&index=0&id=8d35b10c&prod&scoped=true&lang=css"
import style1 from "./CampanhaFormPage.vue?vue&type=style&index=1&id=8d35b10c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d35b10c",
  null
  
)

export default component.exports